import { GenerationLoader } from '@wix/cc-user-facing-common-components';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useRouter } from 'next/router';


import css from './index.module.scss';


export const CopilotLoader = () => {
  const { locale } = useRouter();
  const { t } = useTranslation();

  return <Box direction='vertical' className={css.wrapper}>
    <GenerationLoader locale={locale as string} className={css.loader} />
    <Text weight='thin' size='tiny'>
      {t('article-page.copilot.loader.txt')}
    </Text>
  </Box>;
};
